
import { computed, defineComponent, PropType } from "vue";
// components
import FormModal from "@/components/modals/FormModal.vue";
// store
import useScheduleStore from "@/store/useScheduleStore";
import useEmployeeWorkAreaStore from "@/store/useEmployeeWorkAreaStore";
// other
import { GanttGroup } from "@/components/gantt/useGantt";
import { createFullName } from "@/store/useEmployeeStore";
import { parseTimeString } from "@/utils/dateHelpers";

export enum EmployeeStatus {
  Available = "available",
  Assigned = "assigned",
  Absent = "absent"
}

export default defineComponent({
  name: "DayViewWorkAreaModal",
  components: {
    FormModal
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    group: { type: Object as PropType<GanttGroup>, required: true }
  },
  emits: ["close"],

  setup(props, context) {
    // store
    const { selectedDate, employees, onCreateShift, onCreateShiftSuccess } = useScheduleStore({
      querySelectedSchedule: true
    });
    const { employeeWorkAreas } = useEmployeeWorkAreaStore({ allEmployeeWorkAreas: true });

    // close modal
    const onClose = () => {
      context.emit("close");
    };

    // get assignments of considered work area
    const employeeWorkAreasFiltered = computed(() =>
      employeeWorkAreas.value.filter(item => item.work_area_id === props.group.id)
    );
    // get all employees that are allowed to work in this work area
    const employeeIds = computed(() => employeeWorkAreasFiltered.value.map(item => item.employee_id));
    const workAreaEmployees = computed(() =>
      employees.value?.filter(employee => employeeIds.value?.includes(employee.id))
    );

    // employees that are currently assigned to group
    const shiftsEmployeeIds = computed(() => props.group.tasks.map(task => task.data.employee_id));

    // check if employee is already assigned to shift or is still available
    // can also include check if employee is absent
    const getEmployeeStatus = (employeeId: string) => {
      if (shiftsEmployeeIds.value.includes(employeeId)) return EmployeeStatus.Assigned;
      else return EmployeeStatus.Available;
    };

    // Validate and create shift
    const onAddEmployee = (employeeId: string) => {
      // cancel if employee is not available
      if (getEmployeeStatus(employeeId) != EmployeeStatus.Available) return;
      // create shift
      onCreateShift(
        parseTimeString("07:00", selectedDate.value),
        parseTimeString("15:00", selectedDate.value),
        employeeId,
        props.group.id
      );
    };

    onCreateShiftSuccess(() => {
      console.info("shift created");
      onClose();
    });

    return {
      createFullName,
      workAreaEmployees,
      shiftsEmployeeIds,
      getEmployeeStatus,
      EmployeeStatus,
      onAddEmployee,
      onClose
    };
  }
});
